<template>
  <div id="app" :class="{ 'login-page': isLoginPage }">
    <!-- 登录页面不显示侧边栏 -->
    <template v-if="isLoginPage">
      <router-view></router-view>
    </template>
    <!-- 其他页面显示完整布局 -->
    <template v-else>
      <!-- 侧边栏 -->
      <mycard class="sidebar"></mycard>

      <div class="main">
        <router-view></router-view>
      </div>
    </template>
  </div>
</template>

<script>

import api from './api/api'
import mycard from './components/mycard/mycard.vue'
export default {
  components: {
    mycard
  },
  computed: {
    isLoginPage() {
      // 根据当前路由路径判断是否为登录页面
      return this.$route.path === '/login';
    }
  },
  created() {
    this.checkUrlParams()
    // 初始化数据 - 现在使用本地API服务
  },
  methods: {
    async checkUrlParams() {
      const urlParams = this.getRequestParams();
      console.log('App.vue完整URL参数:', urlParams);
      if (!urlParams) {
              // 优先检查tokenValue是否为空
      const tokenValue = urlParams.token;
         const tokenValueStr = Buffer.from(decodeURIComponent(tokenValue), 'base64').toString();
          console.log(tokenValueStr);
      const authValue = urlParams.auth;
     const authValueStr = Buffer.from(decodeURIComponent(authValue), 'base64').toString();

      this.$nextTick(() => {
      if (tokenValueStr && typeof tokenValueStr === 'string' && tokenValueStr.trim() !== '') {
          const [robotId, userId, token] = tokenValueStr.split("_");
            console.log(token);
             if (token && token.trim() !== '') {
              localStorage.setItem('sx-token', token);
            }
          // 有有效的token参数，跳转到chat.vue，保留查询参数
          if (this.$route.path !== '/chat') {
            this.$router.push({
              path: '/chat',
              query: urlParams // 保留所有查询参数
            });
          }
        } else if (authValueStr && typeof authValueStr === 'string' && authValueStr.trim() !== '') {
          // 有auth参数，跳转到login.vue，保留查询参数
          if (this.$route.path !== '/login') {
            this.$router.push({
              path: '/login',
              query: urlParams // 保留所有查询参数
            });
          }
        }
      });
      } else {

      }



      // 其他参数处理可以放在这里
    },

    // URL参数解析 - 支持hash模式
   getRequestParams() {
  try {
    // 创建一个URL对象
    const urlObj = new URL(window.location.href);

    // 如果是hash路由，需要单独处理hash部分
    const hash = urlObj.hash;
    let params = {};

    if (hash.includes('?')) {
      const hashParams = new URLSearchParams(hash.split('?')[1]);
      params = Object.fromEntries(hashParams.entries());
    } else if (urlObj.search) {
      // 处理普通查询参数
      const searchParams = new URLSearchParams(urlObj.search);
      params = Object.fromEntries(searchParams.entries());
    }

    console.log('App.vue 解析的参数:', params);
    return params;
  } catch (error) {
    console.error('解析URL参数时出错:', error);
    return {};
  }
}
  }
}
</script>

<style lang="less" scoped>
#app {

  // 登录页面的特殊样式
  &.login-page {
    border-radius: 0;
    margin: 0;
    width: 100%;
    height: 100vh;
    background-color: #f5f5f5;
    display: block;
  }

  // 其他页面的默认样式
  &:not(.login-page) {
    display: flex;
    border-radius: 50px;
    margin: 20px auto;
    width: 860px;
    height: 600px;
    background-color: #fff;

    .sidebar {
      width: 60px;
      height: 600px;
      background: #2b2c2f;
    }

    .main {
      flex: 1;
      height: 600px;
      background: #f2f2f2;
    }
  }
}
</style>



// WEBPACK FOOTER //
// App.vue?267cad36